module.exports = __webpack_public_path__ + "img/lzzz1.299c3e44.png";